/**
 * Keeps copy in the page for crawlers without showing it to shoppers.
 *
 * The long-form SEO blocks at the bottom of the marketing pages carry the
 * keyword copy the site is ranked on, so removing them costs rankings. They also
 * read as filler to anyone actually browsing. This renders them into the HTML
 * and the accessibility tree, positioned out of view.
 *
 * Deliberately NOT `display: none` or `visibility: hidden`. Both drop the text
 * from the accessibility tree, and search engines discount them far harder than
 * the off-screen clip technique, which is the same one used for screen-reader
 * text everywhere else on the site.
 */

type Props = {
  children: React.ReactNode;
  /** Extra classes for the wrapper, rarely needed. */
  className?: string;
};

export default function SeoOnly({ children, className }: Props) {
  return <div className={`sr-only${className ? ` ${className}` : ''}`}>{children}</div>;
}
